/* eslint-disable max-len */
import React, { useState } from "react";
import styles from "./styles.css";
import WhiteCard from "../../shared/white-card";
import Button from "../../shared/button";
import InputText from "../../shared/input-text";
import InputMobile from "../../shared/input-mobile";
import nameValidator from "../../../utils/validators/name-validator";
import { validateEmail } from "../../../utils/validators/email-validator";
import OnlineSearch from "../../shared/search/online";
import { pincodeOptions } from "../../../utils/auto-complete/search-options";
import { getErrorWithType, ERR_TYPES, unsetErrorType } from "./selectors";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import ErrorStrip from "../../shared/error-strip";
import PropTypes from "prop-types";
import IconSuccess from "../../shared/icon-success";

const BecomeOurPartnerForm = ({
    name,
    mobile,
    email,
    isSubmitted,
    dealerName,
    selectedPincode,
    onPincodeMenuOpen = () => {},
    setNameConnect,
    setMobileConnect,
    setEmailConnect,
    submitOnBoardingConnect,
    updateIsSubmittedConnect,
    updateDealerNameConnect,
    updatePincodeSelectionConnect
}) => {

    const [pincodeText, setPincodeText] = useState(null);
    const [focusAfterSelection, setFocusAfterSelection] = useState(false);
    const [error, setError] = useState({});

    const getPincodeKey = () => {

        if (selectedPincode) {
            return selectedPincode.label;
        } else {
            return 0;
        }
    };

    const onSubmit = () => {
        let isError = false;
        let errorOb = {};
        const variablesToCheck = [
            {
                key: name,
                type: ERR_TYPES.NAME,
                customValidator: true,
                validator: nameValidator,
                customMessage: true
            },
            {
                key: email,
                type: ERR_TYPES.EMAIL,
                customValidator: true,
                validator: validateEmail,
                customMessage: true
            },
            {
                key: mobile,
                type: ERR_TYPES.MOBILE,
                customValidator: true,
                validator: mobileNumberValidator,
                customMessage: true
            },
            {
                key: selectedPincode,
                type: ERR_TYPES.PINCODE,
                customMessage: true,
                extras: {
                    pincodeText
                }
            },
            {
                key: dealerName,
                type: ERR_TYPES.DEALERSHIP_NAME,
                customValidator: true,
                validator: (value) => !!(value.trim().length)
            }
        ];
        variablesToCheck.forEach((item) => {
            let isKeyError = false;
            /**
            * if custom validator flag is present then
            * validate using the validator present in the object
            * or by default check falsy condition of the variable
            */
            if ((item.customValidator &&
                !item.validator(item.key)) || (!item.customValidator && !item.key)) {
                isKeyError = true;
                isError = true;
            }
            if (isKeyError) {
                errorOb = {
                    ...errorOb,
                    ...getErrorWithType({
                        type: item.type,
                        ...(item.customMessage && {
                            customMessageOptions: {
                                value: item.key,
                                extras: item.extras
                            }
                        })
                    })
                };
            }
        });
        if (!isError) {
            submitOnBoardingConnect({
                Dealers: {
                    full_name: name,
                    pincode_id: selectedPincode.value,
                    mobileno: mobile,
                    email,
                    dealership_name: dealerName
                }
            }).then(() => updateIsSubmittedConnect(true));
        }
        setError(errorOb);
    };

    const onNameBluHandler = () => {
        /**
         * unset error if name is valid
         */
        if (nameValidator(name)) {
            setError(unsetErrorType({
                error,
                type: ERR_TYPES.NAME
            }));
        }
    };

    const onMobileBlurHandler = () => {
        /**
         * unset error if mobile is valid
         */
        if (mobileNumberValidator(mobile)) {
            setError(unsetErrorType({
                error,
                type: ERR_TYPES.MOBILE
            }));
        }
    };

    const onEmailBlurHandler = () => {
        /**
         * unset error if email is valid
         */
        if (validateEmail(email)) {
            setError(unsetErrorType({
                error,
                type: ERR_TYPES.EMAIL
            }));
        }
    };

    const onDealerNameBlurHandler = () => {
        /**
         * unset error if dealer name exists
         */
        if (dealerName.length) {
            setError(unsetErrorType({
                error,
                type: ERR_TYPES.DEALERSHIP_NAME
            }));
        }
    };

    const onPincodeChangeHandler = (data) => {
        setFocusAfterSelection(false);
        updatePincodeSelectionConnect(data);
        setError(unsetErrorType({
            error,
            type: ERR_TYPES.PINCODE
        }));
    };

    const PostSubmissionLayout = () => (
        <div styleName={"styles.thankYou"}>
            <span styleName={"styles.thankyouImage"}>
                <IconSuccess />
            </span>
            <h3>Thank You <br /> {name}!</h3>
            <p> We have got your request to become our channel partner.
        You can download our partner mobile app and continue
         the registration process:</p>
            <p>
                Download Now:
                <a
                    href="https://play.google.com/store/apps/details?id=com.cars24.dealerapp"
                    target="_blank">Android</a> or
                <a
                    href="https://itunes.apple.com/in/app/cars24-channel-partner-app/id1061524131"
                    target="_blank">iOS</a>
            </p>
            <p>
                In case of any query please contact us at
                <a href="tel:011 - 40051118">011 - 40051118</a>
            </p>
        </div>
    );

    return (
        <div styleName={"styles.dealersWrap"} >
            <WhiteCard>
                {
                    isSubmitted ?
                        <PostSubmissionLayout />
                        :
                        (
                            <div styleName={"styles.dealersForm"} >
                                <h3>Register today to transform the Used Car Industry!</h3>
                                <div styleName={"styles.dealersInput"}>
                                    <div styleName={"styles.inputWrapper"}>
                                        <InputText
                                            value={name}
                                            onChange={(e) => setNameConnect(e.target.value)}
                                            onBlurCallback={onNameBluHandler}
                                            validator={nameValidator}
                                            errorMessage={null}
                                            text="Full Name" />
                                        <div styleName={"styles.errorWrap"}>
                                            <ErrorStrip err={error} type={ERR_TYPES.NAME} />
                                        </div>
                                    </div>
                                    <div styleName={"styles.inputWrapper"}>
                                        <OnlineSearch
                                            key={getPincodeKey()}
                                            placeholder="Enter Your Pincode"
                                            onMenuOpen={() => {
                                                onPincodeMenuOpen({
                                                    overrideMenuFocus: setFocusAfterSelection
                                                });
                                            }}
                                            onMenuClose={() => setFocusAfterSelection(false)}
                                            getOptions={pincodeOptions}
                                            focusAfterSelection={focusAfterSelection}
                                            onInputChangeCallback={(text) => {
                                                /**
                                                 * if text is empty & there is a previous selection
                                                 * then reset it
                                                 */
                                                if (!text && selectedPincode) {
                                                    updatePincodeSelectionConnect(null);
                                                }
                                                setPincodeText(text);
                                            }}
                                            customDefaultValue={selectedPincode ? selectedPincode.label : null}
                                            onChange={onPincodeChangeHandler}
                                        />
                                        <div styleName={"styles.errorWrap"}>
                                            <ErrorStrip err={error} type={ERR_TYPES.PINCODE} />
                                        </div>
                                    </div>
                                </div>
                                <div styleName={"styles.dealersInput"}>
                                    <div styleName={"styles.inputWrapper"}>
                                        <InputMobile
                                            value={mobile}
                                            showError = {false}
                                            onChange={(e) => setMobileConnect(e.target.value)}
                                            onBlurCallback={onMobileBlurHandler}
                                            text="Mobile Number" />
                                        <div styleName={"styles.errorWrap"}>
                                            <ErrorStrip err={error} type={ERR_TYPES.MOBILE} />
                                        </div>
                                    </div>
                                    <div styleName={"styles.inputWrapper"}>
                                        <InputText
                                            value={email}
                                            onChange={(e) => setEmailConnect(e.target.value)}
                                            validator={validateEmail}
                                            onBlurCallback={onEmailBlurHandler}
                                            errorMessage={null}
                                            text="Email" />
                                        <div styleName={"styles.errorWrap"}>
                                            <ErrorStrip err={error} type={ERR_TYPES.EMAIL} />
                                        </div>
                                    </div>
                                </div>
                                <InputText
                                    value={dealerName}
                                    showError = {false}
                                    onChange={(e) => updateDealerNameConnect(e.target.value)}
                                    onBlurCallback={onDealerNameBlurHandler}
                                    text="Dealership Name" />
                                <div styleName={"styles.errorWrap"}>
                                    <ErrorStrip err={error} type={ERR_TYPES.DEALERSHIP_NAME} />
                                </div>
                                <Button
                                    onClick={onSubmit}
                                    text="Register Now" />
                                <p>We respect your privacy. Your information is
                        confidential with us.
                                </p>
                            </div>
                        )
                }
            </WhiteCard>
        </div>

    );

};

BecomeOurPartnerForm.propTypes = {
    name: PropTypes.string,
    mobile: PropTypes.string,
    email: PropTypes.string,
    isSubmitted: PropTypes.bool,
    dealerName: PropTypes.string,
    selectedPincode: PropTypes.object,
    setNameConnect: PropTypes.func,
    setMobileConnect: PropTypes.func,
    setEmailConnect: PropTypes.func,
    submitOnBoardingConnect: PropTypes.func,
    updateIsSubmittedConnect: PropTypes.func,
    updateDealerNameConnect: PropTypes.func,
    updatePincodeSelectionConnect: PropTypes.func,
    onPincodeMenuOpen: PropTypes.func
};

export default BecomeOurPartnerForm;
